export enum AssetKind {
  Instance = 'Instance',
  NotApplicable = 'NotApplicable',
  Type = 'Type',
}
